export const PDF_CONFIG = {
  // PDF.js configuration
  cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.0.379/cmaps/',
  cMapPacked: true,
  standardFontDataUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@4.0.379/standard_fonts/',
  
  // Worker configuration
  workerSrc: 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.0.379/pdf.worker.min.js',
  
  // Rendering options
  renderInteractiveForms: false,
  enableXfa: false,
  useSystemFonts: true,
  disableAutoFetch: true,
  disableStream: false,
  
  // Canvas settings
  canvasMaxArea: 96 * 1024 * 1024, // 96MB
  maxImageSize: 4096 * 4096,
  
  // Viewport defaults
  defaultScale: 1.0,
  minScale: 0.25,
  maxScale: 4.0,

  // File validation
  maxFileSize: 10 * 1024 * 1024, // 10MB
  allowedTypes: ['application/pdf'],
  allowedExtensions: ['.pdf'],

  // Performance settings
  maxCanvasPixels: 16777216, // 4096 * 4096
  disableFontFace: false,
  verbosity: 0
};